var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { usePlugFilespaceClient, } from '@lucidlink/workspacemanagement';
import { buildGlobalSetContext, emitGlobalSetTelemetry } from '#telemetry';
import { FilespaceSettingsKeyFactory } from '../query-key-factories';
export const useSetGlobalSettings = ({ filespaceId, setting, workspaceId }, { onError, onSuccess }) => {
    _react_refresh_temp_1();
    const queryClient = useQueryClient();
    const { plugFilespaceClient } = usePlugFilespaceClient();
    const mutation = useMutation({
        mutationKey: FilespaceSettingsKeyFactory.setGlobal(filespaceId, setting),
        onMutate: async (settings) => plugFilespaceClient({
            action: (fsClient) => buildGlobalSetContext(settings, fsClient),
            filespaceId,
            workspaceId,
        }),
        mutationFn: async (settings) => plugFilespaceClient({
            action: (fsClient) => fsClient.globalSettingManager().set(settings),
            filespaceId,
            workspaceId,
        }),
        onSuccess: async (_data, variables, context) => {
            try {
                if (context) {
                    void plugFilespaceClient({
                        action: (fsClient) => Promise.resolve(emitGlobalSetTelemetry(variables, context, fsClient)),
                        filespaceId,
                        workspaceId,
                    });
                }
                await queryClient.refetchQueries({
                    exact: true,
                    queryKey: FilespaceSettingsKeyFactory.global(filespaceId),
                });
            }
            finally {
                if (onSuccess && typeof onSuccess === 'function') {
                    onSuccess(variables);
                }
            }
        },
        onError: (_error, variables) => {
            if (onError && typeof onError === 'function') {
                onError(_error, variables);
            }
        },
        networkMode: 'always',
    });
    return {
        mutation,
    };
};
_react_refresh_temp_1(useSetGlobalSettings, "o0s1hYhUCjAbRTTY8BWLnVP5U/c=", false, () => [useQueryClient, usePlugFilespaceClient, useMutation]);
